import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vuilniszak',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVuilniszak {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m21.34 9.37-1.31 2.62h-3.6l-2.06-3.36c-.34-.41.53-.81 1.26-.58l1.02.32c.68.21 2.22.33 3.02.33h.88c.65 0 1.08.36.79.67m-.08-3.79a.952.952 0 0 0-.19-1.35.47.47 0 0 1-.09-.67c.81-1.06.6-2.57-.48-3.37-.43-.32-1.04-.24-1.37.19s-.24 1.03.19 1.35c.21.16.26.46.1.67-.39.51-.56 1.14-.47 1.78s.43 1.2.95 1.59c.22.16.48.22.72.19s.48-.16.64-.37Zm-4.99 0a.952.952 0 0 0-.19-1.35.47.47 0 0 1-.09-.67c.81-1.06.6-2.57-.48-3.37-.43-.32-1.04-.24-1.37.19s-.24 1.03.19 1.35c.21.16.26.46.1.67-.39.51-.56 1.14-.47 1.78s.43 1.2.95 1.59c.22.16.48.22.72.19s.48-.16.64-.37ZM28.06 32.1c-1.4-2.26-1.77-3.45-1.84-4.05-.06-.48-.1-.72-.14-.93-.04-.21-.07-.38-.11-.82l-.08-1.01c-.16-2.17-.35-5.94-.96-7.3-.55-1.24-2.31-2.57-3.72-3.38-.41-.23-.8-.46-1.09-.65l-1.52-.02-1.74 3.48c-.18.35-.54.55-.91.55-.15 0-.31-.03-.45-.11-.5-.25-.71-.85-.45-1.34l1.33-2.61h-.45c-.29.21-.77.49-1.28.78-1.43.82-3.06 2.09-3.6 3.28-.61 1.36-.8 5.13-.95 7.3l-.08 1.01c-.03.43-.07.6-.11.82-.04.21-.09.45-.14.93-.07.6-.44 1.79-1.84 4.05-.47.76-.57 1.65-.26 2.38.38.93 1.23 1.51 2.2 1.51h16.25c.97 0 1.82-.58 2.2-1.51.3-.74.2-1.63-.26-2.38Z"/>
</svg>

    );
  }
}
